<template>

    <a-modal class="invitation"
             centered
             :width="900"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-card>
            <div class="t1">
                <div class="size4 mb-5 bold" style="color: #EA0000">{{inviteInfo.supplierName}}:</div>
                <div class="size3 t1-a">
                    <p class="">
                        <b>{{inviteInfo.tenderOrg}}</b>受<b>{{inviteInfo.purchaserUnit}}</b>委托，邀请贵单位参与<b>{{inviteInfo.projectName}}</b>
                        项目{{inviteInfo.invitedBidBzxxMcs?'（'+inviteInfo.invitedBidBzxxMcs+'）':''}}投标。
                    </p>
                    <div class="tb-box">
                        <p>投标邀请函下载:</p>
                        <div class="tb-file">
                            <upload-selector ref="UploadSelector1" :referId='inviteInfo.projectId'
                                             readonly configKey='YQH_FILE'/>
                        </div>
                    </div>
                    <div class="tb-box">
                        <p v-show="qtFile">其他附件下载：</p>
                        <div class="tb-file">
                            <upload-selector ref="UploadSelector2" @fileLen="uploadSuccess" :referId='inviteInfo.projectId'
                                             readonly configKey='YQH_FJ_FILE'/>
                        </div>
                    </div>
                    <!--                        不需要提交资格预审-->
                    <div v-if="inviteInfo.xyzgys === '0'">
                        <p>如参加项目投标，请直接在下方链接中购买标书。</p>
                        <p>
                            如不参加或有疑问，请联系我司经办人说明原因<B>{{inviteInfo.tenderOperator}}（{{inviteInfo.tenderTel}}）</B>。感谢贵单位对本次招标工作的支持！
                        </p>
                        <p><a v-if="inviteInfo.fbcggg === '1'" class="color-red" @click="goAttend(inviteInfo.fbcggg)">项目采购公告地址【点击可以报名】
                        </a></p>
                        <p><a v-if="inviteInfo.fbcggg === '0'" class="color-red" @click="goAttend(inviteInfo.fbcggg)">购买项目标书【点击可以报名】
                        </a></p>
                    </div>
                    <!--                需要提交资格审查-->
                    <div v-if="inviteInfo.xyzgys === '1'">
                        <p>如要参加项目投标，请先按投标邀请函的要求准备资格审查文件并在下面链接中上传，资格审查通过后即可购买标书。
                        </p>
                        <p>
                            如不参加或有疑问，请联系我司经办人说明原因<B>（{{inviteInfo.tenderOperator}}{{inviteInfo.tenderTel}}）</B>。感谢贵单位对本次招标工作的支持！
                        </p>
                        <p v-if="!bidZgys"><a  @click="goZgYs">
                            资格审查文件上传地址【点击可以提交资格审查文件】
                        </a></p>
                        <template v-else>
                        <p v-if="bidZgys.commitStatus === '1' && bidZgys.checkStatus === '0' ">
                            您已提交资格审查文件，正在审核中，请耐心等待。
                        </p>
                        <div v-if="bidZgys.commitStatus === '0' && bidZgys.checkStatus === '2' ">
                            <p>您提交的资格审查文件审核不通过，请点击下面的链接查看处理：</p>
                            <p><a @click="goZgYs"> 资格审查文件上传地址【点击可以提交资格审查文件】
                            </a></p>
                        </div>
                        <p v-if="bidZgys.commitStatus && bidZgys.checkStatus === '0' ">
                            资格审查结果在24小时内通过手机短信进行通知。
                        </p>
                        <div v-if="bidZgys.commitStatus === '1' && bidZgys.checkStatus === '1' ">
                            <p> 您提交的资格审查文件已经审核通过，请点击下面的链接进行报名：</p>
                            <p><a v-if="inviteInfo.fbcggg === '1'" class="color-red" @click="goAttend(inviteInfo.fbcggg)">项目采购公告地址【点击可以报名】
                            </a></p>
                            <p><a v-if="inviteInfo.fbcggg === '0'" class="color-red" @click="goAttend(inviteInfo.fbcggg)">购买项目标书【点击可以报名】
                            </a></p>
                        </div>
                        </template>
                    </div>
                </div>
            </div>
            <p class="t2">{{inviteInfo.tenderOrg}}</p>
        </a-card>
    </a-modal>

</template>

<script>
    import qs from 'qs'
    import UploadSelector from '../../components/selector/UploadSelector'

    export default {
        components: {
            UploadSelector
        },
        created() {
        },

        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                packs: '',
                modalLoading: false,
                subjectList: [],
                inviteInfo: '',
                bidZgys: {},
                qtFile:false,
            }
        },
        methods: {
            uploadSuccess(len)
            {
                console.log(len)
                this.qtFile = len > 0
            },
            goZgYs() {
                this.$router.push({path: '/ZgYsFile?projectId=' + this.inviteInfo.projectId})
            },
            goAttend(fbcggg) {
                if ("1" === fbcggg) {
                    if (this.inviteInfo.announceId) {
                        let routeIndex = this.$router.resolve({
                            path: '/project/LegalAnnounce?id=' + this.inviteInfo.announceId
                        })
                        window.open(routeIndex.href, '_blank')
                    }else {
                        this.$warning({
                            title: '请耐心等待经办人发布采购公告！！！'
                        })
                    }
                } else {
                    this.signPermission()
                }
            },
            initData(id) {
                let that = this

                this.$http.get('/api/v1/supplier/project/getLegalInvitedDetails.json?id=' + id).then(function (res) {
                    if (res.code !== 200) {
                        return
                    }
                    that.inviteInfo = res.result
                    that.bidZgys = res.result.bidZgys
                })
            },
            signPermission() {
                let that = this
                that.$http.get('/api/v1/supplier/legalsign/legalSignPermission.json?projectId=' + that.inviteInfo.projectId).then(function (data) {
                    if (data.code === 100) {
                        that.$error({
                            title: '提示',
                            content: data.msg,
                            okText: '确定',
                            onOk() {
                            }
                        })
                    } else if (data.code === 300) {
                        that.showConfirm(data.msg)
                    } else if (data.code === 200) {
                        that.sign()
                    }
                })
            },
            sign() {
                this.$router.push({path: '/LegalSignIndex?id=' + this.inviteInfo.projectId})
            },
            showConfirm(value) {
                let that = this
                this.$confirm({
                    title: "提示",
                    content: value,
                    okText: '立即认证',
                    cancelText: '知道了',
                    onOk() {
                        that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                            that.$router.push({path: '/enterprise/LegalCertificationIndex'});
                        });
                    },
                    onCancel() {
                    }
                });
            },
        }
    }
</script>
<style lang="less" scoped>
    /deep/ .ant-modal-content {
        background: none;
        box-shadow: none;
    }

    /deep/ .ant-card {
        background: url("../../img/p4.png");
        background-size: 850px 640px;
        border: none;
        height: 630px;
    }

    /deep/ .ant-modal-close-x {
        border: 2px solid #fff;
        color: #fff;
        width: 36px;
        height: 36px;
        line-height: 32px;
        border-radius: 18px;
        font-weight: bold;
    }

    /deep/ .ant-modal-close {
        top: -20px;
        right: 20px;
    }

    .t1 {
        overflow-y: auto;
        height: 288px;
        margin: 100px 16px 40px 40px;
        color: #333;
    }

    .t1-a p {
        text-indent: 32px;
        padding: 0 10px 0 30px;
    }

    .tb-box {
        display: flex;
    }

    .tb-file {
        width: 60%;
    }

    .t1-a u {
        cursor: pointer;
    }

    .t2 {
        position: absolute;
        bottom: 20px;
        width: 100%;
        text-align: center;
        color: #FEE7B4;
        left: 0
    }
</style>
